import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        quints_api: {
          header: 'HEADER',
          affiliates_api_link: 'AFFILIATES_API_LINK',
          trackers_api_link: 'TRACKERS_API_LINK',
          copy_trackers_api_link: 'TRACKERS_COPY_LINK',
          copy_affiliates_api_link: 'AFFILIATES_COPY_LINK',
          reset_api_token_button: 'RESET_BUTTON',
          confirm_reset_api_token_modal: {
            title: 'TITLE',
            question: 'QUESTION',
            answer_yes: 'ANSWER_YES',
            answer_no: 'ANSWER_NO',
          },
        },
      },
    },
  }));
}
